import { Col, Row, Tooltip } from 'antd';
import { AppButton, AttachmentsIcon, Flex } from '../common';
import { statusColor, filterIssueAttachments, isSamadUser } from './helpdeskUtils';
import { formatDate, downloadFile } from '@/utils';
import { SAMIN_KEY } from '@/services/http';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export default function HelpdeskIssueDesktop({
  issue,
  styles,
  addNoteModal,
}) {

  const [t] = useTranslation(['common', 'helpdesk']);

  return (
    <Row gutter={[8, 4]} className="w-full text-base">
      <Col span={12}>
        <Flex>
          <span>{t('common:labels.id')}:</span>
          <span>{issue?.id}</span>
        </Flex>
      </Col>
      <Col span={12}>
        <Flex justify="flex-end">
          <span>{issue?.project?.name}</span>
        </Flex>
      </Col>
      <Col span={12}>
        <Flex>
          <span className="font-medium">{issue?.category?.name}</span>
        </Flex>
      </Col>
      <Col span={12}>
        <Flex justify="flex-end">
          <span style={{ color: statusColor[issue?.status?.name] }}>
            {issue?.status?.name}
          </span>
        </Flex>
      </Col>
      <Col flex="1" className="mt-6">
        <Col span={24} flex="1">
          <Flex direction="column" className={classNames(styles.box.base, 'w-[90%]')}>
            <div className={styles.box.title}>{issue?.subject}</div>
            <div className="text-mid">{issue?.description}</div>
            <Flex gap={8} className="ms-auto mt-auto" inlineFlex>
              {filterIssueAttachments(issue)?.map(att => (
                <Tooltip key={att.id} title={t('helpdesk:labels.download-attachment')}>
                  <div
                    className="p-0 m-0 cursor-pointer"
                    onClick={() => downloadFile(att.content_url + '?key=' + SAMIN_KEY, att.filename)}>
                    <AttachmentsIcon style={{ fontSize: '1.85rem' }}
                    />
                  </div>
                </Tooltip>
              ))}
            </Flex>
          </Flex>
        </Col>

        <Flex gap="2rem" direction="column" className="mt-4">
          {issue?.journals?.map((journal, i) => {
            if (journal?.notes?.trim() === '') return '';
            const details = journal?.details.filter(x => x.property === 'attachment');
            const journalAttachments = issue?.attachments?.filter(att => details.some(ja => ja.name === String(att.id)));
            return (
              <Flex
                key={i}
                gap={0}
                direction="column"
                className={classNames('w-[90%]', isSamadUser(journal.user) ? '' : 'ms-auto')}
              >
                <Flex direction="row">
                  <span className="text-sm">{journal?.user?.name}</span>
                  <span className="text-sm ms-auto">
                    {formatDate(journal.created_on, 'jYYYY/jMM/jDD')}
                  </span>
                </Flex>
                <Flex
                  direction="column"
                  className={classNames(
                    styles.box.base,
                    'w-full h-auto p-4',
                    isSamadUser(journal.user) ? '' : 'bg-app-gray-extra-light'
                  )}
                >
                  <div className="text-mid">{journal.notes}</div>
                  {journalAttachments.length !== 0 &&
                    <Flex align="center" direction="row">
                      <Flex gap={8} className="ms-auto mt-auto" inlineFlex>
                        {journalAttachments?.map((att) => (
                          <Tooltip key={att.id} title={t('helpdesk:labels.download-attachment')}>
                            <div
                              className="p-0 m-0 cursor-pointer"
                              onClick={() => downloadFile(att.content_url + '?key=' + SAMIN_KEY, att.filename)}>
                              <AttachmentsIcon style={{ fontSize: '1.85rem' }} />
                            </div>
                          </Tooltip>
                        ))}
                      </Flex>
                    </Flex>
                  }
                </Flex>
              </Flex>
            );
          })}
          <AppButton
            ghost
            type="primary"
            onClick={addNoteModal.show}
            className="my-4 !font-medium !text-app-blue !border-app-blue">
            title={t('helpdesk:labels.new-reply')}
          </AppButton>
        </Flex>
      </Col>
    </Row>
  );
}
